// Fonte: UManutContas.dfm — Painel P2, Ds_ClienteComercio → tabela Cliente_Joia (63 colunas)
import React, { useState } from 'react';
import { Form, Row, Col, Card, Collapse, Button } from 'react-bootstrap';
import Select from 'react-select';
import { FaChevronDown, FaChevronUp, FaGlobe } from 'react-icons/fa';
import aplicarMascara from './mascaras';
import ModalPerfilExterior from './ModalPerfilExterior';

// Fonte: UManutContas.dfm, RxEstadoCivil — Items.Strings / Values.Strings (linhas 10117-10139)
var ESTADO_CIVIL = [
  { value: 'T', label: 'Solteiro' },
  { value: 'C', label: 'Casado em regime de comunhão de bens' },
  { value: 'P', label: 'Casado em regime de comunhão parcial de bens' },
  { value: 'S', label: 'Casado em regime de separação total de bens' },
  { value: 'E', label: 'Casado em regime de participação final nos aquestos' },
  { value: 'J', label: 'Separado Judicialmente' },
  { value: 'D', label: 'Divorciado' },
  { value: 'V', label: 'Viúvo' },
  { value: 'U', label: 'União Estável' },
  { value: 'B', label: 'Casado em regime de comunhão universal de bens' },
];

var TIPO_PESSOA = [
  { value: '0', label: 'Física' },
  { value: '1', label: 'Jurídica' },
];

var SEXO = [
  { value: 'M', label: 'Masculino' },
  { value: 'F', label: 'Feminino' },
];

// Fonte: UManutContas.dfm, RxDBComboBox14 — Items.Strings (28 DETRANs)
var ORGAO_EMISSOR_CNH = [
  { value: 'DETRAN/AC', label: 'DETRAN/AC' },
  { value: 'DETRAN/AL', label: 'DETRAN/AL' },
  { value: 'DETRAN/AM', label: 'DETRAN/AM' },
  { value: 'DETRAN/AP', label: 'DETRAN/AP' },
  { value: 'DETRAN/BA', label: 'DETRAN/BA' },
  { value: 'DETRAN/BH', label: 'DETRAN/BH' },
  { value: 'DETRAN/CE', label: 'DETRAN/CE' },
  { value: 'DETRAN/DF', label: 'DETRAN/DF' },
  { value: 'DETRAN/ES', label: 'DETRAN/ES' },
  { value: 'DETRAN/GO', label: 'DETRAN/GO' },
  { value: 'DETRAN/MA', label: 'DETRAN/MA' },
  { value: 'DETRAN/MG', label: 'DETRAN/MG' },
  { value: 'DETRAN/MS', label: 'DETRAN/MS' },
  { value: 'DETRAN/MT', label: 'DETRAN/MT' },
  { value: 'DETRAN/PA', label: 'DETRAN/PA' },
  { value: 'DETRAN/PB', label: 'DETRAN/PB' },
  { value: 'DETRAN/PE', label: 'DETRAN/PE' },
  { value: 'DETRAN/PI', label: 'DETRAN/PI' },
  { value: 'DETRAN/PR', label: 'DETRAN/PR' },
  { value: 'DETRAN/RJ', label: 'DETRAN/RJ' },
  { value: 'DETRAN/RN', label: 'DETRAN/RN' },
  { value: 'DETRAN/RO', label: 'DETRAN/RO' },
  { value: 'DETRAN/RR', label: 'DETRAN/RR' },
  { value: 'DETRAN/RS', label: 'DETRAN/RS' },
  { value: 'DETRAN/SC', label: 'DETRAN/SC' },
  { value: 'DETRAN/SE', label: 'DETRAN/SE' },
  { value: 'DETRAN/SP', label: 'DETRAN/SP' },
  { value: 'DETRAN/TO', label: 'DETRAN/TO' },
];

var FormTipo2 = function(_ref) {
  var formik = _ref.formik;
  var modoEdicao = _ref.modoEdicao;
  var lookups = _ref.lookups;
  var lookupsLoading = _ref.lookupsLoading;
  var ge = _ref.ge;
  var codigo = _ref.codigo;
  var isNovo = _ref.isNovo;

  var vendedores = (lookups && lookups.vendedores) ? lookups.vendedores : [];
  var cidades = (lookups && lookups.cidades) ? lookups.cidades : [];
  var perfis = (lookups && lookups.perfis) ? lookups.perfis : [];
  var cobradores = (lookups && lookups.cobradores) ? lookups.cobradores : [];
  var cargos = (lookups && lookups.cargos) ? lookups.cargos : [];

  var [showPerfilExterior, setShowPerfilExterior] = useState(false);

  var val = function(campo) {
    var v = formik.values['tipo2'] ? formik.values['tipo2'][campo] : undefined;
    return v !== null && v !== undefined ? v : '';
  };

  var handleChange = function(e) {
    formik.setFieldValue('tipo2.' + e.target.name, e.target.value);
  };

  var handleMasked = function(name, tipo) {
    return function(e) {
      formik.setFieldValue('tipo2.' + name, aplicarMascara(e.target.value, tipo));
    };
  };

  var valMask = function(campo, tipo) {
    return aplicarMascara(val(campo), tipo);
  };

  var isPessoaFisica = val('tipo_pessoa') === '0';
  var isCIN = val('is_documento_cin') === true;

  // Fonte: UManutContas.dfm L9843/L10016/L10060 — DDD, UF e País readonly de Ds_Tab_Cidades
  var cidadeSelecionada = cidades.find(function(c) { return c.value === val('codigo_cidade'); });
  var ddd = cidadeSelecionada && cidadeSelecionada.ddd !== undefined && cidadeSelecionada.ddd !== null ? String(cidadeSelecionada.ddd) : '';
  var uf = cidadeSelecionada && cidadeSelecionada.uf ? cidadeSelecionada.uf : '';
  var pais = cidadeSelecionada && cidadeSelecionada.pais ? cidadeSelecionada.pais : '';

  var [aberto, setAberto] = useState(true);

  return (
    <>
    <Card className="shadow-sm mb-3">
      <Card.Header className="py-2 contas-card-header" style={{ cursor: 'pointer' }} onClick={function() { setAberto(!aberto); }}>
        <div className="d-flex justify-content-between align-items-center">
          <strong>Dados do Tipo: Cliente Comércio</strong>
          {aberto ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
        </div>
      </Card.Header>
      <Collapse in={aberto}>
        <div>
      <Card.Body>
        {/* Linha 1: Identificação */}
        <Row>
          <Col md={4} className="mb-3">
            <Form.Label className="small mb-1">Nome / Razão Social *</Form.Label>
            <Form.Control
              type="text" size="sm" name="razao_social"
              value={val('razao_social')} onChange={handleChange}
              maxLength={100} disabled={!modoEdicao}
            />
          </Col>
          <Col md={3} className="mb-3">
            <Form.Label className="small mb-1">CPF/CNPJ *</Form.Label>
            <Form.Control
              type="text" size="sm" name="cpf"
              value={valMask('cpf', 'cpf')} onChange={handleMasked('cpf', 'cpf')}
              maxLength={18} disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Tipo Pessoa *</Form.Label>
            <Select
              options={TIPO_PESSOA}
              value={TIPO_PESSOA.find(function(t) { return t.value === val('tipo_pessoa'); }) || null}
              onChange={function(opt) {
                formik.setFieldValue('tipo2.tipo_pessoa', opt ? opt.value : '');
              }}
              isDisabled={!modoEdicao}
            />
          </Col>
          <Col md={3} className="mb-3">
            <Form.Label className="small mb-1">Vendedor *</Form.Label>
            <Select
              placeholder="Selecione..."
              options={vendedores}
              value={vendedores.find(function(v) { return v.value === val('vendedor'); }) || null}
              onChange={function(opt) {
                formik.setFieldValue('tipo2.vendedor', opt ? opt.value : '');
              }}
              isDisabled={!modoEdicao || lookupsLoading}
              isLoading={lookupsLoading}
              noOptionsMessage={function() { return 'Nenhum vendedor'; }}
            />
          </Col>
        </Row>

        {/* Linha 2: Endereço */}
        <Row>
          <Col md={3} className="mb-3">
            <Form.Label className="small mb-1">Endereço *</Form.Label>
            <Form.Control
              type="text" size="sm" name="endereco"
              value={val('endereco')} onChange={handleChange}
              maxLength={40} disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Bairro</Form.Label>
            <Form.Control
              type="text" size="sm" name="bairro"
              value={val('bairro')} onChange={handleChange}
              maxLength={20} disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">CEP</Form.Label>
            <Form.Control
              type="text" size="sm" name="cep"
              value={valMask('cep', 'cep')} onChange={handleMasked('cep', 'cep')}
              maxLength={9} disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Cidade *</Form.Label>
            <Select
              placeholder="Selecione a cidade..."
              options={cidades}
              value={cidades.find(function(c) { return c.value === val('codigo_cidade'); }) || null}
              onChange={function(opt) {
                formik.setFieldValue('tipo2.codigo_cidade', opt ? opt.value : '');
              }}
              isDisabled={!modoEdicao || lookupsLoading}
              isLoading={lookupsLoading}
              noOptionsMessage={function() { return 'Nenhuma cidade'; }}
            />
          </Col>
          <Col md={1} className="mb-3">
            <Form.Label className="small mb-1">UF</Form.Label>
            <Form.Control type="text" size="sm" value={uf} readOnly disabled />
          </Col>
          <Col md={1} className="mb-3">
            <Form.Label className="small mb-1">DDD</Form.Label>
            <Form.Control type="text" size="sm" value={ddd} readOnly disabled />
          </Col>
          <Col md={1} className="mb-3">
            <Form.Label className="small mb-1">País</Form.Label>
            <Form.Control type="text" size="sm" value={pais} readOnly disabled />
          </Col>
        </Row>

        {/* Linha 3: Contato */}
        <Row>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Fone Com.</Form.Label>
            <Form.Control
              type="text" size="sm" name="fone1"
              value={valMask('fone1', 'fone')} onChange={handleMasked('fone1', 'fone')}
              maxLength={14} disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Fone Res.</Form.Label>
            <Form.Control
              type="text" size="sm" name="fone2"
              value={valMask('fone2', 'fone')} onChange={handleMasked('fone2', 'fone')}
              maxLength={14} disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Fax</Form.Label>
            <Form.Control
              type="text" size="sm" name="fax"
              value={valMask('fax', 'fone')} onChange={handleMasked('fax', 'fone')}
              maxLength={14} disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Celular</Form.Label>
            <Form.Control
              type="text" size="sm" name="celular_contato"
              value={valMask('celular_contato', 'celular')} onChange={handleMasked('celular_contato', 'celular')}
              maxLength={15} disabled={!modoEdicao}
            />
          </Col>
          <Col md={4} className="mb-3">
            <Form.Label className="small mb-1">E-mail</Form.Label>
            <Form.Control
              type="email" size="sm" name="email"
              value={val('email')} onChange={handleChange}
              disabled={!modoEdicao}
            />
          </Col>
        </Row>

        {/* Linha 4: Documentos — CIN/RG/Org.Emissor/Dt.Exp visíveis para PF e PJ */}
        {/* Fonte: UManutContas.pas — RG visível para PJ como "Ins. Estadual" */}
        <Row>
          {isPessoaFisica && (
            <Col md={1} className="mb-3 d-flex align-items-end pb-1">
              <Form.Check
                type="checkbox"
                label="CIN"
                checked={val('is_documento_cin') === true}
                onChange={function(e) {
                  formik.setFieldValue('tipo2.is_documento_cin', e.target.checked);
                }}
                disabled={!modoEdicao}
              />
            </Col>
          )}
          {(!isPessoaFisica || !isCIN) && (
            <>
              <Col md={2} className="mb-3">
                <Form.Label className="small mb-1">{isPessoaFisica ? 'RG' : 'RG / Ins. Estadual'}</Form.Label>
                <Form.Control
                  type="text" size="sm" name="rg"
                  value={val('rg')} onChange={handleChange}
                  disabled={!modoEdicao}
                />
              </Col>
              <Col md={2} className="mb-3">
                <Form.Label className="small mb-1">Orgão Emissor</Form.Label>
                <Form.Control
                  type="text" size="sm" name="org_emissor"
                  value={val('org_emissor')} onChange={handleChange}
                  disabled={!modoEdicao}
                />
              </Col>
              <Col md={2} className="mb-3">
                <Form.Label className="small mb-1">Dt. Expedição</Form.Label>
                <Form.Control
                  type="date" size="sm" name="data_exp"
                  value={val('data_exp')} onChange={handleChange}
                  disabled={!modoEdicao}
                />
              </Col>
            </>
          )}
        </Row>

        {/* Linha 4b: Sexo, Estado Civil, Dt. Nascimento — somente PF */}
        {isPessoaFisica && (
          <Row>
            <Col md={2} className="mb-3">
              <Form.Label className="small mb-1">Sexo *</Form.Label>
              <Select
                options={SEXO}
                value={SEXO.find(function(s) { return s.value === val('sexo'); }) || null}
                onChange={function(opt) {
                  formik.setFieldValue('tipo2.sexo', opt ? opt.value : '');
                }}
                isDisabled={!modoEdicao}
              />
            </Col>
            <Col md={3} className="mb-3">
              <Form.Label className="small mb-1">Estado Civil *</Form.Label>
              <Select
                options={ESTADO_CIVIL}
                value={ESTADO_CIVIL.find(function(e) { return e.value === val('estado_civil'); }) || null}
                onChange={function(opt) {
                  formik.setFieldValue('tipo2.estado_civil', opt ? opt.value : '');
                }}
                isDisabled={!modoEdicao}
              />
            </Col>
            <Col md={2} className="mb-3">
              <Form.Label className="small mb-1">Dt. Nascimento</Form.Label>
              <Form.Control
                type="date" size="sm" name="data_nascimento"
                value={val('data_nascimento')} onChange={handleChange}
                disabled={!modoEdicao}
              />
            </Col>
          </Row>
        )}

        {/* Linha 5: Dados adicionais */}
        <Row>
          <Col md={3} className="mb-3">
            <Form.Label className="small mb-1">Naturalidade</Form.Label>
            <Form.Control
              type="text" size="sm" name="naturalidade"
              value={val('naturalidade')} onChange={handleChange}
              disabled={!modoEdicao}
            />
          </Col>
          <Col md={3} className="mb-3">
            <Form.Label className="small mb-1">Tabelião</Form.Label>
            <Form.Control
              type="text" size="sm" name="tabeliao"
              value={val('tabeliao')} onChange={handleChange}
              disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">N° Passaporte/CIN</Form.Label>
            <Form.Control
              type="text" size="sm" name="n_passaporte"
              value={val('n_passaporte')} onChange={handleChange}
              disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">CNH</Form.Label>
            <Form.Control
              type="text" size="sm" name="cnh"
              value={val('cnh')} onChange={handleChange}
              disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Emissor CNH</Form.Label>
            <Select
              placeholder="Selecione..."
              options={ORGAO_EMISSOR_CNH}
              value={ORGAO_EMISSOR_CNH.find(function(o) { return o.value === val('orgao_emissor_cnh'); }) || null}
              onChange={function(opt) {
                formik.setFieldValue('tipo2.orgao_emissor_cnh', opt ? opt.value : '');
              }}
              isDisabled={!modoEdicao}
              isClearable
            />
          </Col>
        </Row>
        <Row>
          <Col md={3} className="mb-3">
            <Form.Label className="small mb-1">Perfil Comprador</Form.Label>
            <Select
              placeholder="Selecione..."
              options={perfis}
              value={perfis.find(function(p) { return p.value === val('codigo_perfil_comprador'); }) || null}
              onChange={function(opt) {
                formik.setFieldValue('tipo2.codigo_perfil_comprador', opt ? opt.value : null);
              }}
              isDisabled={!modoEdicao || lookupsLoading}
              isLoading={lookupsLoading}
              isClearable
              noOptionsMessage={function() { return 'Nenhum perfil'; }}
            />
          </Col>
          <Col md={3} className="mb-3">
            <Form.Label className="small mb-1">Cobrador</Form.Label>
            <Select
              placeholder="Selecione..."
              options={cobradores}
              value={cobradores.find(function(c) { return c.value === val('cobrador'); }) || null}
              onChange={function(opt) {
                formik.setFieldValue('tipo2.cobrador', opt ? opt.value : null);
              }}
              isDisabled={!modoEdicao || lookupsLoading}
              isLoading={lookupsLoading}
              isClearable
              noOptionsMessage={function() { return 'Nenhum cobrador'; }}
            />
          </Col>
          <Col md={2} className="mb-3 d-flex align-items-end pb-1">
            <Form.Check
              type="checkbox"
              label="Emancipado"
              checked={val('emancipado') === 'S'}
              onChange={function(e) {
                formik.setFieldValue('tipo2.emancipado', e.target.checked ? 'S' : 'N');
              }}
              disabled={!modoEdicao}
            />
          </Col>
          {/* Fonte: UManutContas.dfm, btnEndExterior — 20/02/2024:Rogerio - s60/i1604 */}
          {!isNovo && ge && codigo && (
            <Col md={2} className="mb-3 d-flex align-items-end pb-1">
              <Button
                variant="outline-info" size="sm"
                onClick={function() { setShowPerfilExterior(true); }}
              >
                <FaGlobe className="mr-1" /> End. Exterior
              </Button>
            </Col>
          )}
        </Row>

        {/* Contatos — Fonte: Panel18 no .dfm */}
        <div className="contas-section-title mt-3">Contatos</div>
        <Row>
          <Col md={4} className="mb-2">
            <Form.Label className="small mb-1">Nome Contato 1</Form.Label>
            <Form.Control
              type="text" size="sm" name="contato"
              value={val('contato')} onChange={handleChange}
              disabled={!modoEdicao}
            />
          </Col>
          <Col md={3} className="mb-2">
            <Form.Label className="small mb-1">Cargo</Form.Label>
            <Select
              placeholder="Selecione..."
              options={cargos}
              value={cargos.find(function(c) { return c.value === val('cargo'); }) || null}
              onChange={function(opt) {
                formik.setFieldValue('tipo2.cargo', opt ? opt.value : null);
              }}
              isDisabled={!modoEdicao || lookupsLoading}
              isLoading={lookupsLoading}
              isClearable
              noOptionsMessage={function() { return 'Nenhum cargo'; }}
            />
          </Col>
        </Row>
        <Row>
          <Col md={4} className="mb-2">
            <Form.Label className="small mb-1">Nome Contato 2</Form.Label>
            <Form.Control
              type="text" size="sm" name="contato2"
              value={val('contato2')} onChange={handleChange}
              disabled={!modoEdicao}
            />
          </Col>
          <Col md={3} className="mb-2">
            <Form.Label className="small mb-1">Cargo</Form.Label>
            <Select
              placeholder="Selecione..."
              options={cargos}
              value={cargos.find(function(c) { return c.value === val('cargo2'); }) || null}
              onChange={function(opt) {
                formik.setFieldValue('tipo2.cargo2', opt ? opt.value : null);
              }}
              isDisabled={!modoEdicao || lookupsLoading}
              isLoading={lookupsLoading}
              isClearable
              noOptionsMessage={function() { return 'Nenhum cargo'; }}
            />
          </Col>
          <Col md={2} className="mb-2">
            <Form.Label className="small mb-1">Dt. Nascimento</Form.Label>
            <Form.Control
              type="date" size="sm" name="aniver2"
              value={val('aniver2')} onChange={handleChange}
              disabled={!modoEdicao}
            />
          </Col>
          <Col md={3} className="mb-2">
            <Form.Label className="small mb-1">Celular</Form.Label>
            <Form.Control
              type="text" size="sm" name="celular2"
              value={valMask('celular2', 'celular')} onChange={handleMasked('celular2', 'celular')}
              maxLength={15} disabled={!modoEdicao}
            />
          </Col>
        </Row>
        <Row>
          <Col md={4} className="mb-2">
            <Form.Label className="small mb-1">Nome Contato 3</Form.Label>
            <Form.Control
              type="text" size="sm" name="contato3"
              value={val('contato3')} onChange={handleChange}
              disabled={!modoEdicao}
            />
          </Col>
          <Col md={3} className="mb-2">
            <Form.Label className="small mb-1">Cargo</Form.Label>
            <Select
              placeholder="Selecione..."
              options={cargos}
              value={cargos.find(function(c) { return c.value === val('cargo3'); }) || null}
              onChange={function(opt) {
                formik.setFieldValue('tipo2.cargo3', opt ? opt.value : null);
              }}
              isDisabled={!modoEdicao || lookupsLoading}
              isLoading={lookupsLoading}
              isClearable
              noOptionsMessage={function() { return 'Nenhum cargo'; }}
            />
          </Col>
          <Col md={2} className="mb-2">
            <Form.Label className="small mb-1">Dt. Nascimento</Form.Label>
            <Form.Control
              type="date" size="sm" name="aniver3"
              value={val('aniver3')} onChange={handleChange}
              disabled={!modoEdicao}
            />
          </Col>
          <Col md={3} className="mb-2">
            <Form.Label className="small mb-1">Celular</Form.Label>
            <Form.Control
              type="text" size="sm" name="celular3"
              value={valMask('celular3', 'celular')} onChange={handleMasked('celular3', 'celular')}
              maxLength={15} disabled={!modoEdicao}
            />
          </Col>
        </Row>
      </Card.Body>
        </div>
      </Collapse>
    </Card>
    <ModalPerfilExterior
      show={showPerfilExterior}
      ge={ge}
      codigo={codigo}
      onHide={function() { setShowPerfilExterior(false); }}
    />
    </>
  );
};

export default FormTipo2;
